import { Loader2 } from 'lucide-react'

interface LoadingOverlayProps {
  progress: string
}

export const LoadingOverlay = ({ progress }: LoadingOverlayProps) => {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4 shadow-2xl">
        <div className="flex flex-col items-center">
          <Loader2 className="w-16 h-16 text-indigo-600 animate-spin mb-6" />
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            Проверяем карточку
          </h3>
          <p className="text-gray-600 text-center mb-6">
            {progress || 'Это может занять до минуты...'}
          </p>

          {/* Индетерминированная анимация — бегущая полоска */}
          <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
            <div
              className="bg-indigo-600 h-full rounded-full"
              style={{
                width: '40%',
                animation: 'indeterminate 1.5s infinite ease-in-out'
              }}
            />
          </div>
          <style>{`
            @keyframes indeterminate {
              0% { transform: translateX(-100%); }
              100% { transform: translateX(350%); }
            }
          `}</style>

          <p className="text-sm text-gray-500 mt-4">
            Пожалуйста, не закрывайте страницу
          </p>
        </div>
      </div>
    </div>
  )
}